import { render, staticRenderFns } from "./BuyInfo.vue?vue&type=template&id=3d49d240&"
import script from "./BuyInfo.vue?vue&type=script&lang=js&"
export * from "./BuyInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports